import React, { useState } from "react";

import styles from "./ModuleAccordion.module.scss";
import { useRouter } from "next/router";
import RichTextParser from "../RichTextParser";
import ReactMarkdown from 'react-markdown';

function ModulEachAccordian({ _id, contentTypeId, headerText, summaryText, summaryRichText, index, openIndex, setOpenIndex, parent_contentTypeId }) {

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    }

    return (
        <div className={styles.accordianContainer} >

            <div className={styles.wrapcontainer} onClick={() => handleToggle(index)}>
                <h3 className={styles.headertext}>{headerText}</h3>
                <button className={parent_contentTypeId === "pageCourseTopic" ? styles.arrowbutton : styles.newarrowbutton}>
                    {openIndex === index ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.25 14.75L11.75 8.5L18.25 14.75" stroke="#1A1918" strokeWidth="1.5" strokeMiterlimit="10" />
                    </svg>
                        : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.25 9.25L11.75 15.5L18.25 9.25" stroke="#1A1918" strokeWidth="1.5" strokeMiterlimit="10" />
                        </svg>
                    }
                </button>
            </div>

            <div className={`${styles.slideSummaryText} ${openIndex === index ? styles.visible : styles.hidden}`}>
                {summaryRichText ? (
                    <RichTextParser document={summaryRichText} />
                ) : (
                    <ReactMarkdown>{summaryText}</ReactMarkdown>
                )}
            </div>

        </div>

    )




}






export default ModulEachAccordian